// ======================================================================
// File Name       : csvDownload
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/csvDownload';

const initialState = {
  learningHistoryCSVDownload: {
    selectedRange: '0',
    targetContent: '0',
    selectedCourseBox: [],
    selectedGroup: [],
    progressStatusType: '0',
    selectedCompletionType: '0',
  },
  loginHistoryCSVDownload: {
    targetUserType: '-1',
  },
  isSelected: false,
  isShowGroupNumber: false,
  isLearningHistoryCSVPage: false,
  serviceUsers: {
    userList: [],
    recordNum: 0,
  },
  targetCourse: {
    bySecernId: {},
    allSecernIds: [],
    recordNum: 0,
  },
  targetContent: {
    bySecernId: {},
    allSecernIds: [],
    recordNum: 0,
  },
  targetUser: {
    bySecernId: {},
    allSecernIds: [],
    recordNum: 0,
  },
  targetBox: {
    bySecernId: {},
    allSecernIds: [],
    recordNum: 0,
  },
  storedUserList: {
    bySecernId: {},
    allSecernIds: [],
  },
  storedCourseList: {
    bySecernId: {},
    allSecernIds: [],
  },
  storedContentList: {
    bySecernId: {},
    allSecernIds: [],
  },
  storedBoxList: {
    bySecernId: {},
    allSecernIds: [],
  },
  addedCourseList: {},
  addedContentList: {},
  addedUserList: {},
  targetCourseList: {},
  targetContentList: {},
  targetUserList: {},
  targetBoxList: {},
  courses: {},
  boxes: {},
  userServiceSearchConditions: {},
  courseSearchConditions: {},
  contentSearchConditions: {},
  addedBoxList: {},
};

export default function csvDownload(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.CSV_RESET_SELECTED_COURSE_BOX_LIST: {
      state.learningHistoryCSVDownload.selectedCourseBox = [];
      // Reset target course
      state.targetCourseList = {};
      state.addedCourseList = {};
      // Reset target item
      state.targetContentList = {};
      state.addedContentList = {};
      // Reset box item
      state.targetBoxList = {};
      state.addedBoxList = {};

      return {
        ...state,
      };
    }
    case ActionTypes.CSV_RECEIVE_SELECTED_GROUP: {
      const { selectedGroupList } = action;
      state.learningHistoryCSVDownload.selectedGroup = selectedGroupList;
      return {
        ...state,
        isShowGroupNumber: true,
      };
    }
    case ActionTypes.CSV_RESET_SELECTED_GROUP_LIST: {
      state.learningHistoryCSVDownload.selectedGroup = [];
      // Reset user
      state.targetUserList = {};
      state.addedUserList = {};
      return {
        ...state,
      };
    }
    case ActionTypes.CSV_RESET_SELECTED_FLAG: {
      const { flag } = action;
      return {
        ...state,
        isSelected: flag,
      };
    }
    case ActionTypes.CSV_OPEN_SELECT_GROUP_DIALOG: {
      const { flag } = action;
      return {
        ...state,
        isOpenSelectGroup: flag,
      };
    }
    case ActionTypes.CSV_RESET_SHOW_GROUP_FLAG: {
      const { flag, isLearningHistoryCSV } = action;
      return {
        ...state,
        isShowGroupNumber: flag,
        isLearningHistoryCSVPage: isLearningHistoryCSV,
      };
    }
    case ActionTypes.CSV_RECEIVE_SERVICE_USER_LIST: {
      const { users, recordNum, storedUserList, searchCondition } = action;
      return {
        ...state,
        targetUser: {
          recordNum,
          allSecernIds: users.allSecernIds,
          bySecernId: users.bySecernId,
        },
        storedUserList,
        userServiceSearchConditions: { ...searchCondition },
      };
    }
    case ActionTypes.CSV_RECEIVE_COURSE_LIST: {
      const { courseList, recordNum, searchCondition } = action;
      const { storedCourseList } = state;
      const targetCourse = courseList.reduce((acc, cur) => {
        const { courseSecernId } = cur;
        acc.bySecernId[courseSecernId] = cur;
        acc.allSecernIds.push(courseSecernId);
        if (!storedCourseList.bySecernId[courseSecernId]) {
          storedCourseList.bySecernId[courseSecernId] = cur;
        }
        if (storedCourseList.allSecernIds.indexOf(courseSecernId) < 0) {
          storedCourseList.allSecernIds.push(courseSecernId);
        }
        return acc;
      }, { recordNum, bySecernId: {}, allSecernIds: [] });

      if (searchCondition && Object.keys(searchCondition).length > 0) {
        return {
          ...state,
          targetCourse,
          storedCourseList,
          courseSearchConditions: searchCondition,
        };
      }

      return {
        ...state,
        targetCourse,
        storedCourseList,
        courseSearchConditions: {},
      };
    }

    // Step 10.0.0 START
    case ActionTypes.CSV_RECEIVE_BOX_LIST: {
      const { boxList, recordNum, searchCondition } = action;
      const { storedBoxList } = state;
      const targetBox = boxList.reduce((acc, cur) => {
        const { boxSecernId } = cur;
        acc.bySecernId[boxSecernId] = cur;
        acc.allSecernIds.push(boxSecernId);
        if (!storedBoxList.bySecernId[boxSecernId]) {
          storedBoxList.bySecernId[boxSecernId] = cur;
        }
        if (storedBoxList.allSecernIds.indexOf(boxSecernId) < 0) {
          storedBoxList.allSecernIds.push(boxSecernId);
        }
        return acc;
      }, { recordNum, bySecernId: {}, allSecernIds: [] });

      if (searchCondition && Object.keys(searchCondition).length > 0) {
        return {
          ...state,
          targetBox,
          storedBoxList,
          courseSearchConditions: searchCondition,
        };
      }

      return {
        ...state,
        targetBox,
        storedBoxList,
        courseSearchConditions: {},
      };
    }
    // Step 10.0.0 END

    case ActionTypes.CSV_RECEIVE_ADDED_COURSE_LIST: {
      const { removedSecern, addedList, removedAll } = action;
      if (removedAll) {
        return {
          ...state,
          addedCourseList: {},
        };
      }
      const addedCourseList = { ...state.addedCourseList };
      delete addedCourseList[removedSecern];
      const courses = state.storedCourseList.bySecernId;
      addedList.forEach((courseSecernId, index) => {
        if (courses && courses[courseSecernId]) {
          addedCourseList[courseSecernId] = courses[courseSecernId];
          addedCourseList[courseSecernId].addNew = true;
          addedCourseList[courseSecernId].index = index;
        }
      });
      return {
        ...state,
        addedCourseList,
      };
    }

    // Step 10.0.0 START
    case ActionTypes.CSV_RECEIVE_ADDED_BOX_LIST: {
      const { removedSecern, addedList, removedAll } = action;
      if (removedAll) {
        return {
          ...state,
          addedBoxList: {},
        };
      }

      const addedBoxList = { ...state.addedBoxList };
      delete addedBoxList[removedSecern];
      const boxes = state.storedBoxList.bySecernId;
      addedList.forEach((boxSecernId, index) => {
        if (boxes && boxes[boxSecernId]) {
          addedBoxList[boxSecernId] = boxes[boxSecernId];
          addedBoxList[boxSecernId].addNew = true;
          addedBoxList[boxSecernId].index = index;
        }
      });

      return {
        ...state,
        addedBoxList,
      };
    }
    // Step 10.0.0 END

    case ActionTypes.CSV_RECEIVE_TARGET_COURSE_LIST: {
      const { addedCourseList } = action;
      let { targetCourseList } = state;
      targetCourseList = addedCourseList;
      return {
        ...state,
        targetCourseList,
      };
    }

    // Step 10.0.0 START
    case ActionTypes.CSV_RECEIVE_TARGET_BOX_LIST: {
      const { addedBoxList } = action;
      let { targetBoxList } = state;
      targetBoxList = addedBoxList;
      return {
        ...state,
        targetBoxList,
      };
    }
    // Step 10.0.0 END

    case ActionTypes.CSV_RESET_DATA: {
      const { targetCourseList } = state;
      let { addedCourseList } = state;
      addedCourseList = { ...targetCourseList };
      return {
        ...state,
        addedCourseList,
      };
    }
    case ActionTypes.CSV_RECEIVE_ITEM_LIST: {
      const { items, recordNum, storedContentList, searchCondition } = action;
      if (searchCondition && Object.keys(searchCondition).length > 0) {
        return {
          ...state,
          targetContent: {
            recordNum,
            allSecernIds: items.allSecernIds,
            bySecernId: items.bySecernId,
          },
          storedContentList,
          contentSearchConditions: searchCondition,
        };
      }

      return {
        ...state,
        targetContent: {
          recordNum,
          allSecernIds: items.allSecernIds,
          bySecernId: items.bySecernId,
        },
        storedContentList,
        contentSearchConditions: {},
      };
    }
    case ActionTypes.CSV_RECEIVE_ADDED_CONTENT_LIST: {
      const { removedSecern, addedList, removedAll } = action;
      if (removedAll) {
        return {
          ...state,
          addedContentList: {},
        };
      }
      const addedContentList = { ...state.addedContentList };
      delete addedContentList[removedSecern];
      const items = state.storedContentList.bySecernId;
      addedList.forEach((itemSecernId, index) => {
        if (items && items[itemSecernId]) {
          addedContentList[itemSecernId] = items[itemSecernId];
          addedContentList[itemSecernId].addNew = true;
          addedContentList[itemSecernId].index = index;
        }
      });
      return {
        ...state,
        addedContentList,
      };
    }
    case ActionTypes.CSV_RECEIVE_ADDED_USER_LIST: {
      const { removedSecern, addedList, removedAll } = action;

      if (removedAll) {
        return {
          ...state,
          addedUserList: {},
        };
      }
      const addedUserList = { ...state.addedUserList };
      delete addedUserList[removedSecern];
      const users = state.storedUserList.bySecernId;
      addedList.forEach((userSecernId, index) => {
        if (users && users[userSecernId]) {
          addedUserList[userSecernId] = users[userSecernId];
          addedUserList[userSecernId].addNew = true;
          addedUserList[userSecernId].index = index;
        }
      });
      return {
        ...state,
        addedUserList,
      };
    }
    case ActionTypes.CSV_RECEIVE_TARGET_CONTENT_LIST: {
      const { addedContentList } = action;
      let { targetContentList } = state;
      targetContentList = addedContentList;
      return {
        ...state,
        targetContentList,
      };
    }
    case ActionTypes.CSV_RECEIVE_TARGET_USER_LIST: {
      const { addedUserList } = action;
      let { targetUserList } = state;
      targetUserList = addedUserList;
      return {
        ...state,
        targetUserList,
      };
    }
    case ActionTypes.CSV_RESET_CONTENT_DATA: {
      const { targetContentList } = state;
      let { addedContentList } = state;
      addedContentList = { ...targetContentList };
      return {
        ...state,
        addedContentList,
      };
    }
    case ActionTypes.CSV_RESET_USER_DATA: {
      const { targetUserList } = state;
      let { addedUserList } = state;
      addedUserList = { ...targetUserList };
      return {
        ...state,
        addedUserList,
      };
    }

    // Step 10.0.0 START
    case ActionTypes.CSV_RESET_BOX_DATA: {
      const { targetBoxList } = state;
      let { addedBoxList } = state;
      addedBoxList = { ...targetBoxList };
      return {
        ...state,
        addedBoxList,
      };
    }
    // Step 10.0.0 END

    case ActionTypes.CSV_RESET: {
      const { learningHistoryCSVDownload } = state;
      learningHistoryCSVDownload.selectedGroup = [];
      return {
        ...state,
        selectedGroup: [],
        targetCourseList: {},
        targetContentList: {},
        targetUserList: {},
        isOpenSelectGroup: false,
        learningHistoryCSVDownload,
        targetBoxList: {},
      };
    }
    case ActionTypes.CSV_RESET_USER_DIALOG: {
      return {
        ...state,
        targetUser: {
          bySecernId: {},
          allSecernIds: [],
          recordNum: 0,
        },
      };
    }
    case ActionTypes.CSV_RESET_COURSE_DIALOG: {
      return {
        ...state,
        targetCourse: {
          bySecernId: {},
          allSecernIds: [],
          recordNum: 0,
        },
      };
    }

    // Step 10.0.0 START
    case ActionTypes.CSV_RESET_BOX_DIALOG: {
      return {
        ...state,
        targetBox: {
          bySecernId: {},
          allSecernIds: [],
          recordNum: 0,
        },
      };
    }
    // Step 10.0.0 END

    case ActionTypes.CSV_RESET_CONTENT_DIALOG: {
      return {
        ...state,
        targetContent: {
          bySecernId: {},
          allSecernIds: [],
          recordNum: 0,
        },
      };
    }

    default: {
      const { learningHistoryCSVDownload, loginHistoryCSVDownload } = initialState;
      return {
        ...state,
        learningHistoryCSVDownload,
        loginHistoryCSVDownload,
      };
    }
  }
}

